import {TRANSLATION, Yup} from '@/imports-files/pages/admins/login';

export const INITIAL_VALUES = {
  email: '',
  password: '',
  name: ''
};

export const VALIDATION_SCHEMA = Yup.object({
  email: Yup.string()
      .email(TRANSLATION('errors:invalid_email'))
      .required(TRANSLATION('errors:required')),
  password: Yup.string()
      .required(TRANSLATION('errors:required')),
});
